import type { SVGProps } from "react";

export function BerryIcon(props: SVGProps<SVGSVGElement>) {
  return (
    <svg
      {...props}
      viewBox="0 0 24 24"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M17 15.0002C17.7956 15.0002 18.5587 15.3163 19.1213 15.8789C19.6839 16.4415 20 17.2046 20 18.0002C20 18.7959 19.6839 19.559 19.1213 20.1216C18.5587 20.6842 17.7956 21.0002 17 21.0002C16.2044 21.0002 15.4413 20.6842 14.8787 20.1216C14.3161 19.559 14 18.7959 14 18.0002C14 17.2046 14.3161 16.4415 14.8787 15.8789C15.4413 15.3163 16.2044 15.0002 17 15.0002ZM17 15.0002C15.667 12.6672 14.667 9.66725 16 6.00025M9 13.0002C9.366 11.0002 10.866 9.12725 13.5 7.40025M16 6.00025C12.333 3.33325 8.667 3.33325 5 6.00025C8.667 8.66725 12.333 8.66725 16 6.00025ZM4 16.5002C4 17.4285 4.36875 18.3187 5.02513 18.9751C5.6815 19.6315 6.57174 20.0002 7.5 20.0002C8.42826 20.0002 9.3185 19.6315 9.97487 18.9751C10.6313 18.3187 11 17.4285 11 16.5002C11 15.572 10.6313 14.6818 9.97487 14.0254C9.3185 13.369 8.42826 13.0002 7.5 13.0002C6.57174 13.0002 5.6815 13.369 5.02513 14.0254C4.36875 14.6818 4 15.572 4 16.5002Z"
        stroke="currentColor"
        strokeWidth="1.6"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </svg>
  );
}
